import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { getSoftwarePortfolios } from "../../services/portfolio.service";

import SoftwarePortfolioItem from "../portfolio/software/softwarePortfolioItem";

export default function TopPortfolios() {
  const [softwarePortfolios, setSoftwarePortfolios] = useState();

  useEffect(() => {
    const fetchSoftwarePortfolios = () => {
      getSoftwarePortfolios().then((res) => {
        const result = res.data.length > 4 ? res.data.slice(0, 4) : res.data
        setSoftwarePortfolios(result);
      }).catch((err) => {
        console.log(err);
      });
    }

    fetchSoftwarePortfolios();
  }, [])

  return (
    <div className="relative py-24 transition-colors duration-300 dark:bg-dark-bg sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-base font-medium text-primary dark:text-secondary">Selected work</p>
          <h2 className="mt-3 text-balance text-4xl font-semibold tracking-tight text-gray-900 dark:text-white sm:text-5xl">
            Our latest web projects
          </h2>
          <p className="mt-4 text-lg/8 text-gray-600 dark:text-gray-400">
            Projects where we partnered with businesses to design, build, and improve custom digital experiences.
          </p>
        </div>
        <div className="mx-auto mt-16 grid max-w-2xl auto-rows-fr grid-cols-1 gap-8 sm:mt-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          {softwarePortfolios && softwarePortfolios.map((portfolio) => {
            return (
              <SoftwarePortfolioItem key={portfolio.id} portfolio={portfolio}/>
            );
          })}
        </div>

        <div className="mt-8 flex flex-row justify-center">
          <Link
            to="/portfolio/software?filter=web"
            className="rounded-lg border border-primary/20 bg-white px-5 py-2 text-sm font-medium text-primary transition duration-200 hover:border-secondary hover:text-primary dark:border-white/10 dark:bg-white/10 dark:text-white dark:hover:text-secondary"
          >
            See more projects
          </Link>
        </div>
      </div>
    </div>
  )
}
